<template>
  <div>
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <StatusModal
          :show.sync="modals.successModal"
          :message="modal.success"
          :title="modal.successTitle"
        />
        <StatusModal
          :show.sync="modals.removeModal"
          :message="modal.remove"
          :title="modal.removeTitle"
        />
        <StatusModal
          :show.sync="modals.removeFailedModal"
          :message="modal.removeFailed"
          :title="modal.removeTitle"
        />
        <div class="col-lg-6 text-left">
          <el-select
            placeholder="Select status"
            v-model="selects.status"
            @change="getData()"
            filterable
          >
            <el-option
              v-for="option in selects.statuses"
              class="select-info custom-option"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <el-input
            type="search"
            class="mb-3 search-input"
            prefix-icon="el-icon-search"
            placeholder="Search Ref No..."
            v-model="searchQuery"
            aria-controls="datatables"
          ></el-input>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div id="tableku" v-if="!load">
              <el-table
                :data="queriedData"
                style="width: 100%; color: #A5A5A5"
                height="700"
                :header-cell-style="{
                  background: 'transparent',
                  color: 'black',
                }"
                class="custom-table"
                @row-click="clickRow"
                :row-class-name="rowHover"
              >
                <el-table-column
                  :min-width="50"
                  align="center"
                  prop="index"
                  label="NO"
                >
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="refno"
                  label="REFERENCE NO"
                >
                  <template slot-scope="{ row }">
                    <p style="color: #358CCB" class="job-no-title">
                      {{ row.refno }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  sortable
                  prop="datecreated"
                  label="DATE CREATED"
                >
                <div slot-scope="{ row }">
                      {{ moment(row.datecreated).format(
                        "DD MMM YYYY"
                      ) }}</div>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  sortable
                  align="center"
                  prop="collectiondate"
                  label="COLLECTION DATE"
                >
                <div slot-scope="{ row }">
                      {{ moment(row.collectiondate).format(
                        "DD MMM YYYY"
                      ) }}</div>
              </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="jobduration"
                  label="STATUS"
                >
                  <template slot-scope="{ row }">
                    <p :style="{ color: row.statuscolor }">
                      {{ row.statusname }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="jobduration"
                  label="JOB DURATION"
                >
                  <template slot-scope="{ row }">
                    <p :style="{ color: row.durationcolor }">
                      {{ row.jobduration }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="appointment"
                  label="APPOINTMENT"
                >
                  <template slot-scope="{ row }">
                    <p :style="{ color: row.appointmentcolor }">
                      {{ row.appointment }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="ptw"
                  label="PTW"
                >
                  <template slot-scope="{ row }">
                    <p :style="{ color: row.ptwcolor }">
                      {{ row.ptw }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="150"
                  align="center"
                  prop="cn"
                  label="CN"
                >
                  <template slot-scope="{ row }">
                    <p
                      :style="{
                        color: row.cncolor == 'blue' ? '#358CCB' : row.cncolor,
                      }"
                    >
                      {{ row.cn }}
                    </p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="d-flex justify-content-center spinner" v-else>
              <circle-8></circle-8>
            </div>
          </card>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select v-model="pagination.perPage" placeholder="Per page">
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";
import { getStorage } from "../../../util/storage";

export default {
  name: "VendorJob",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    BCard,
    StatusModal,
  },

  data() {
    return {
      pagestatus: 0,
      statusname: "-",
      proof: null,
      roleid: 0,
      path: "",
      currentsaleid: "",
      currentstatus: "",
      modal: modal,

      allquotationdocs: [],
      allpaymentproof: [],
      allproformafile: [],
      alldisputedocsmanage: [],

      uploadload: false,

      proposedate: "20/09/2020",
      pickupdate: "12/10/2021",
      statuspickupdate: false,
      pickuplocation: "Cyberjaya",
      reason: "",
      newdate: "",
      modals: {
        rejectdate: false,
        disputereason: false,
        viewrejectreason: false,
        viewquotation: false,
        viewdeliveryorder: false,
        viewproforma: false,
        viewother: false,
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
      },
      transportrate: 0,
      referenceno: "",
      subjectline: "",
      customer: "-",
      picname: "-",
      picphoneno: "-",
      servicelocation: "-",
      customerremark: "",
      deliveryterm: "",
      deliverytermunit: "",
      paymentterm: "",
      validity: "",
      remarks: "",

      wastejobid: 0,

      selectedFileName: "",
      allfilename: [],
      allorderitems: [
        {
          orderid: "2bcc1e04-c002-443c-86b3-4ec76d9f4c22",
          quantity: 9,
          rate: 10.3,
          rate_cent: 0,
          remark: "ko",
          waste_type: {
            waste_type_id: 18,
            name: "Category Y substance",
          },
        },
        {
          orderid: "53d4642a-0e63-4d00-9176-b031e2df7995",
          quantity: 9,
          rate: 90.8,
          rate_cent: 0,
          remark: "ok",
          waste_type: {
            waste_type_id: 11,
            name: "Oily bilge water",
          },
        },
      ],
      tableDatas: [
        {
          status: "accept",
          refno: "L-WCOA",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "accepted",
          refno: "L-WCOB",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "declined",
          refno: "L-WCOC",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "view",
          refno: "L-WCOD",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "accept",
          refno: "L-WCOA",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "accept",
          refno: "L-WCOA",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
        {
          status: "accept",
          refno: "L-WCON",
          datecreated: "31-08-2023",
          collectiondate: "31-08-2023",
          jobduration: "Completed",
          appointment: "",
          ptw: "",
          cn: "",
        },
      ],
      load: false,
      jobnum: "",

      refno: [
        {
          prop: "refno",
          label: "REFERENCE NO",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],

        type: "",
        types: [
          { value: "00", label: "All" },
          { value: "01", label: "Waste" },
          { value: "02", label: "Product" },
        ],
        status: "",
        statuses: [],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30, 50],
        total: 0,
      },
    };
  },
  methods: {
    clickRow(row) {
      let action = "";
      if (
        row.status == 1 ||
        row.status == 2 ||
        row.status == 3 ||
        row.status == 6
      ) {
        action = "edit";
      } else if (row.status == 4 || row.status == 5 || row.status == 100) {
        action = "view";
      }
      this.$router.push("/Vendor/Job/" + row.outgoingid + "/" + action);
    },
    onFileChangeDisputedocsManagement(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/quotation-dispute-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("why");
                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },

    removeDisputedocsManagement(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/quotation-dispute-document/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    disputeQuotation() {
      if (this.reason != "") {
        let obj = {
          remark: this.reason,
        };

        this.$http
          .put(
            ":10001/api/v1/shop/quote/" +
              this.currentsaleid +
              "/quotation/dispute",
            obj
          )
          .then((res) => {
            if (!res.error) {
              swal({
                title: `Success!`,
                text: "Quotation dispution success.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              }).then((result) => {
                console.log(result);
                if (result.value) {
                  this.modals.disputereason = false;
                }
              });
            } else {
              console.log("quote not approve", response);
            }
          })
          .catch((err) => {
            swal({
              title: `Error!`,
              text: "Quotation dispution failed.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-cancel btn-fill",
              type: "error",
            });
          });
      } else {
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },

    acceptQuotation() {
      this.$http
        .put(
          ":10001/api/v1/shop/quote/" + this.currentsaleid + "/quotation/accept"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Quotation acceptance success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewproforma = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Quotation acceptance failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    completeDeliveryOrder() {
      this.$http
        .post(":10001/api/v1/shop/quote/" + this.currentsaleid + "/complete")
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Completion success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewdeliveryorder = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Completion failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    submitProforma() {
      this.$http
        .post(
          ":10001/api/v1/shop/quote/" +
            this.currentsaleid +
            "/document/invoice-document/submit"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Submission success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.modals.viewproforma = false;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Submission failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    removeProof(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/invoice-document/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeProof(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/invoice-document",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("why");
                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },

    removeQuoDoc(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/accept-quotation/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getRowData(this.currentsaleid, "");
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeQuoDoc(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map((file) => file.name).join(", ");

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/shop/quote/" +
                this.currentsaleid +
                "/document/accept-quotation",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                setTimeout(() => {
                  this.getRowData(this.currentsaleid);
                }, 1000);
                this.message = response;
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.btnsubmit = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.uploadload = false;
            this.buttondisabled = false;
          });
      } else {
        this.quotitle = "";
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },

    // clickRow(row) {
    //   this.getRowData(row.saleid, row.statusid);

    //   this.currentsaleid = row.saleid;
    //   this.currentstatus = row.statusid;

    //   if (row.statusid == 3) {
    //     this.modals.viewquotation = true;
    //   } else if (row.statusid == 6) {
    //     this.modals.viewproforma = true;
    //   } else if (row.statusid == 7 || row.statusid == 8 || row.statusid == 100) {
    //     this.modals.viewdeliveryorder = true;
    //   } else {
    //     this.modals.viewother = true;
    //   }
    // },
    rowHover(row) {
      const status = row.status;
      // if (status === 'Review Quotation' || status === 'Ready for pickup' || status === 'Proforma Invoice Ready') {
      //   return 'hover-row';
      // }
      return "hover-row";
    },
    getDisputeReason(row, flag) {
      if (flag === "quo") {
        this.reason = row.disputereason;
        this.modals.viewrejectreason = true;
      } else if (flag === "job") {
        this.reason = row.jobdisputereason;
        this.modals.viewrejectreason = true;
      }
    },
    getStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/status/outgoing?type=waste").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].status,
              value: response[i].value,
            };
            this.selects.statuses.push(obj);
          }
        }
      });

      this.selects.status = 0;
    },
    camelCase(str) {
      if (str !== "") {
        let splitStr = str.toLowerCase().split(" ");
        for (let i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(" ");
      }
      return str;
    },

    getReview(data) {
      this.jobnum = data.refno;
      this.$router.push("/Land/Review/" + this.jobnum);
    },

    getReferenceNo() {
      this.$http.get(":10001/api/v1/incoming/generate").then((res) => {
        if (!res.error) {
          let response = res.message;

          this.referenceno = response.reference_no;
          this.wastejobid = response.waste_job_id;

          this.$router.push("/Land/RequestJob/" + this.referenceno + "/add");
        }
      });
    },

    // getJobPage(data) {
    //   this.jobnum = data.refno;
    //   if (data.status.toUpperCase() === "DRAFT") {
    //     this.$router.push("/Land/RequestJob/" + this.jobnum + "/edit");
    //   } else {
    //     this.$router.push("/Land/RequestJob/" + this.jobnum + "/view");
    //   }
    // },

    getRowData(saleid, status) {
      this.allorderitems = [];
      this.allquotationdocs = [];
      this.allpaymentproof = [];
      this.allproformafile = [];
      this.alldisputedocsmanage = [];

      this.$http.get(":10001/api/v1/shop/quote/" + saleid).then((res) => {
        if (!res.error) {
          let response = res.message;

          (this.transportrate =
            response.transport_rate == null
              ? parseFloat(0).toFixed(2)
              : parseFloat(response.transport_rate).toFixed(2)),
            (this.statusname = response.status.name);
          this.pagestatus = response.status.status;

          this.referenceno =
            response.reference_number == null || response.reference_number == ""
              ? "-"
              : response.reference_number;
          this.subjectline =
            response.subject_line == null ? "-" : response.subject_line;
          // this.customer = response.subject_line == null ? '-' : response.subject_line;
          if (response.pic != null) {
            this.picname =
              response.pic.user_name == null ? "-" : response.pic.user_name;
            this.picphoneno =
              response.pic.phone_number == null
                ? "-"
                : response.pic.phone_number;
          }
          if (response.service_location != null)
            this.servicelocation =
              response.service_location.location == null
                ? "-"
                : response.service_location.location;
          this.customerremark =
            response.customer_remark == null || response.customer_remark == ""
              ? "-"
              : response.customer_remark;
          this.deliveryterm =
            response.delivery_term == null ? "-" : response.delivery_term;
          this.deliverytermunit =
            response.delivery_term_unit == null
              ? "-"
              : response.delivery_term_unit;
          this.paymentterm =
            response.payment_term == null ? "-" : response.payment_term;
          this.validity = response.validity == null ? "-" : response.validity;
          this.remarks = response.remark == null ? "-" : response.remark;

          if (response.order_ready_by != null)
            this.proposedate = response.order_ready_by;

          if (response.order_ready_at != null)
            this.pickuplocation = response.order_ready_at;

          var totalamount = 0;
          for (let i = 0; i < response.order.length; i++) {
            let wastetype = {
              wastetypeid: response.order[i].waste_type.waste_type_id,
              name: response.order[i].waste_type.name,
            };

            let obj = {
              indexing: i + 1,
              orderid: response.order[i].sale_quotation_id,
              quantity: response.order[i].quantity,
              remark: response.order[i].remark,
              waste_type: wastetype,
              rate: parseFloat(response.order[i].rate).toFixed(2),
              ratecent: parseFloat(response.order[i].rate_cent).toFixed(2),
              amount: (
                parseFloat(response.order[i].quantity) *
                parseFloat(response.order[i].rate)
              ).toFixed(2),
            };
            var amount = response.order[i].quantity * response.order[i].rate;
            totalamount += amount;
            this.allorderitems.push(obj);
          }
          let transportrate = {
            wastetypeid: 0,
            name: "Transportation rate",
          };
          let grandtotal = {
            wastetypeid: 0,
            name: "GRAND TOTAL",
          };
          if (status == 3 || status == 100) {
            this.allorderitems.push({
              amount: totalamount,
              waste_type: transportrate,
            });
            this.allorderitems.push({
              amount: (
                parseFloat(totalamount) + parseFloat(this.transportrate)
              ).toFixed(2),
              waste_type: grandtotal,
            });
          } else this.allorderitems.push({});

          if (response.quotation_document != null)
            for (var i = 0; i < response.quotation_document.length; i++) {
              let obj = {
                filename: response.quotation_document[i].meta.filename,
                fileurl: response.quotation_document[i].url,
                fileid: response.quotation_document[i].document_id,
              };
              this.allquotationdocs.push(obj);
            }

          //get quo docs
          if (response.invoice_document != null)
            for (var i = 0; i < response.invoice_document.length; i++) {
              let obj = {
                filename: response.invoice_document[i].meta.filename,
                fileurl: response.invoice_document[i].url,
                fileid: response.invoice_document[i].document_id,
              };
              this.allpaymentproof.push(obj);
            }

          if (response.performa_invoice_document != null)
            for (
              var i = 0;
              i < response.performa_invoice_document.length;
              i++
            ) {
              let obj = {
                filename: response.performa_invoice_document[i].meta.filename,
                fileurl: response.performa_invoice_document[i].url,
                fileid: response.performa_invoice_document[i].document_id,
              };
              this.allproformafile.push(obj);
            }

          if (response.quotation_dispute_document != null)
            for (
              var i = 0;
              i < response.quotation_dispute_document.length;
              i++
            ) {
              let obj = {
                filename: response.quotation_dispute_document[i].meta.filename,
                fileurl: response.quotation_dispute_document[i].url,
                fileid: response.quotation_dispute_document[i].document_id,
              };
              this.alldisputedocsmanage.push(obj);
            }
        }
      });
    },

    getData() {
      this.tableDatas = [];
      this.temp = [];

      console.log("sini ha" + this.selects.status);

      this.$http
        .get(
          ":10001/api/v1/outgoing/waste?size=" +
            this.pagination.perPage +
            "&page=" +
            this.pagination.currentPage +
            "&status=" +
            this.selects.status
        )
        .then((res) => {
          if (!res.error) {
            this.pagination.total = res.message.total;

            let response = res.message.items;

            if (response != null)
              for (let i = 0; i < response.length; i++) {
                let createdAt = moment(response[i].created_at);
                let orderReadyAt = moment(response[i].order_ready_at);
                let durationInMinutes = orderReadyAt.diff(createdAt, "minutes"); // Get total duration in minutes

                let hours = Math.floor(durationInMinutes / 60); // Get hours
                let minutes = durationInMinutes % 60; // Get remaining minutes

                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  status: response[i].status.status,
                  statusname: response[i].status.name,
                  statuscolor: response[i].status.status_color,
                  outgoingid: response[i].outgoing_id,
                  refno: response[i].reference_number,
                  datecreated: 
                  // moment(
                    response[i].created_at
                  // ).format(
                    // "YYYY-MM-DD"
                  // )
                  ,
                  collectiondate: 
                  // moment(
                    response[i].order_ready_at
                  // ).format(
                    // "YYYY-MM-DD"
                  // )
                  ,
                  jobduration: `${hours} H ${minutes} M`,
                  durationcolor:
                    hours > 60 ? "red" : hours > 20 ? "orange" : "#0AAB00",
                  appointment: response[i].appointment.name,
                  appointmentcolor: response[i].appointment.status_color,
                  ptw: response[i].ptw_status.name,
                  ptwcolor: response[i].ptw_status.status_color,
                  cn: response[i].cn_status.name,
                  cncolor: response[i].cn_status.status_color,
                };
                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
          }
        });
    },
    gobrowse() {
      this.$router.push("/Land/BrowseProduct");
    },
  },
  created() {
    this.getStatus();
    this.getData();

    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );

    if (this.roleid == 2) {
      this.path = "Land";
    } else if (this.roleid == 3) {
      this.path = "Vessel";
    }
    // this.tableDatas = this.temp;
  },
  computed: {
    cansubmit() {
      return this.allpaymentproof.length === 0;
    },
    candispute() {
      return this.reason === "";
    },
    canreject() {
      return this.newdate === "";
    },
    canapprove() {
      return this.allquotationdocs.length === 0;
    },
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    // to() {
    //   let highBound = this.from + this.pagination.perPage;
    //   if (this.total < highBound) {
    //     highBound = this.total;
    //   }
    //   return highBound;
    // },
    // from() {
    //   return this.pagination.perPage * (this.pagination.currentPage - 1);
    // },
    // total() {
    //   return this.searchedData.length > 0
    //     ? this.searchedData.length
    //     : this.tableDatas.length;
    // },
  },
  watch: {
    search() {
      this.getData();
    },
    searchQuery: debounce(function (search) {
      if (search !== "") {
        this.tableDatas = this.temp.filter(
          (value) => value.refno.toLowerCase().includes(search.toLowerCase())
          // ||
          // value.picname.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
    "pagination.currentPage"() {
      this.getData();
    },
    "pagination.perPage"() {
      this.getData();
    },
    "pagination.total"() {
      console.log(this.pagination);
      console.log("pagination : ", this.pagination.total);
    },
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["refno"],
      threshold: 1.0,
    });
  },
};
</script>

<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: blue;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.job-no-title2 {
  color: #A5A5A5;
  text-decoration: none;
}

.job-no-title2:hover {
  color: #A5A5A5;
  text-decoration: underline;
  cursor: pointer;
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.hover-row {
  cursor: pointer;
}

.nothover-row {
  /* cursor: normal; */
}

.card .card-header {
  text-align: center;
}

.newtitle {
  color: #707070 !important;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  margin-top: -5px;
  color: #A5A5A5 !important;
}
</style>
